import React from 'react';
import Modal from './Modal';
import PrimaryButton from './PrimaryButton';
import { useLang } from '../context/LangContext';

interface SessionExpiredModalProps {
  isOpen: boolean;
  onConfirm: () => void;
}

// 국제화 텍스트
const sessionExpiredTexts = {
  ko: {
    header: '로그인 만료',
    body: '개인정보 보호를 위해 로그인이 만료되었습니다.\n다시 로그인 해 주세요.',
    loginButton: '로그인 하기'
  },
  en: {
    header: 'Session Expired',
    body: 'For your security, your session has expired.\nPlease log in again.',
    loginButton: 'Go to Login'
  }
};

const SessionExpiredModal: React.FC<SessionExpiredModalProps> = ({
  isOpen,
  onConfirm
}) => {
  const { lang } = useLang();
  const texts = sessionExpiredTexts[lang];

  return (
    <Modal
      isOpen={isOpen}
      // onClose를 제공하지 않거나, 빈 함수로 처리하여 모달 외부 클릭으로 닫히지 않게 함
      // (반드시 재로그인을 하도록 유도)
      onClose={() => {}} 
      header={texts.header}
      bgColor="white"
      body={texts.body}
      footer={
        <PrimaryButton onClick={onConfirm}>
          {texts.loginButton}
        </PrimaryButton>
      }
    />
  );
};

export default SessionExpiredModal;
